export function roundAccurately(num: number, decimalPlaces: number): number {
  return Number(Math.round(`${num}e${decimalPlaces}`) + 'e-' + decimalPlaces)
}
